import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as Api from './api';

export const GRADING_QUERY_KEY = ['grading', 'pending'] as const;

export const usePendingGrading = (orgId: string | undefined) =>
  useQuery<Api.PendingAttempt[]>({
    queryKey: [...GRADING_QUERY_KEY, orgId],
    enabled: Boolean(orgId),
    queryFn: async () => {
      const res = await Api.GetPending();
      return (res.data as Api.PendingAttempt[]) ?? [];
    },
  });

export const useGradeManual = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Api.GradeManualData) => Api.GradeManual(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GRADING_QUERY_KEY });
    },
  });
};

export const useAiSuggest = () =>
  useMutation({
    mutationFn: ({ attemptId, questionId, language }: { attemptId: string; questionId: string; language: string }) =>
      Api.AiSuggest(attemptId, questionId, language),
  });
